let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("aHG2I"), load("bJvam"), load("h0RCh")]).then(() => parcelRequire('a6XIl'));